var cov_2cf855qhp2 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/index.ts",
      hash = "16580ce4e898d29a83be43515cd4f7fffcbcf296",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 18
        },
        end: {
          line: 10,
          column: 23
        }
      },
      "1": {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 11,
          column: 59
        }
      },
      "2": {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 70
        }
      },
      "3": {
        start: {
          line: 13,
          column: 0
        },
        end: {
          line: 13,
          column: 20
        }
      },
      "4": {
        start: {
          line: 14,
          column: 0
        },
        end: {
          line: 14,
          column: 58
        }
      },
      "5": {
        start: {
          line: 15,
          column: 0
        },
        end: {
          line: 15,
          column: 26
        }
      },
      "6": {
        start: {
          line: 17,
          column: 0
        },
        end: {
          line: 17,
          column: 42
        }
      },
      "7": {
        start: {
          line: 18,
          column: 0
        },
        end: {
          line: 18,
          column: 46
        }
      },
      "8": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 33
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _Card from './Card';
import Submit from './Submit';
import { consumer } from './context';
import Header from './Header';
import Body from './Body';
import Footer from './Footer';
import Accordion from './Accordion';
var Card = (cov_2cf855qhp2.s[0]++, _Card);
cov_2cf855qhp2.s[1]++;
Card.Header = consumer(Header, ['collapsed', 'onCollapse']);
cov_2cf855qhp2.s[2]++;
Card.Body = consumer(Body, ['collapsed', 'collapsible', 'onCollapse']);
cov_2cf855qhp2.s[3]++;
Card.Footer = Footer;
cov_2cf855qhp2.s[4]++;
Card.Submit = consumer(Submit, ['onSubmit', 'formStatus']);
cov_2cf855qhp2.s[5]++;
Card.Accordion = Accordion;
cov_2cf855qhp2.s[6]++;
Card.Body.displayName = 'ShineoutCardBody';
cov_2cf855qhp2.s[7]++;
Card.Header.displayName = 'ShineoutCardHeader';
cov_2cf855qhp2.s[8]++;
Card.displayName = 'ShineoutCard';
export default Card;